<template>
  <div class="mt-5 pb-5">
    <b-button
      tag="router-link"
      type="is-success"
      :to="{ name: 'live.edit.stage.edit.geofence.manage' }"
      icon-left="pen"
      label="Configurer les geofences"
      class="mb-4"
    />
    <div class="level">
      <div class="level-left">
        <h3 class="title is-5 level-item">Geofences</h3>
      </div>
      <div class="level-right" />
    </div>

    <b-message type="is-warning" has-icon>
      Cette fonctionnalité est réservée <strong>aux balises Queclink</strong>.
      <br />
      Les changements apportés au cours d'une étape
      <strong>ne seront pas appliqués immédiatement</strong>.
      <br />
      La mise à jour prendra effet une fois que les balises auront récupéré
      <strong>automatiquement</strong> leur configuration (voir estimation ci-dessus). Il est
      possible de <strong>forcer la mise à jour</strong> en resynchronisant manuellement les
      balises.
    </b-message>

    <live-tracker-geofence-table
      :tracker-geofences="trackerGeofences"
      :live-categories="liveCategories"
      @update:trackerGeofences="$emit('update:trackerGeofences', $event)"
    />
  </div>
</template>

<script>
import LiveTrackerGeofenceTable from './LiveTrackerGeofenceTable.vue'

export default {
  name: 'EditLiveTrackerGeofenceTab',

  components: {
    LiveTrackerGeofenceTable,
  },

  props: {
    liveCategories: {
      type: Array,
      required: true,
    },
    trackerGeofences: {
      type: Array,
      required: true,
    },
  },
}
</script>
